var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 502.4 502.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M436.091,269.867L321.957,201.6c1.067-5.333,2.133-10.667,2.133-16c0-33.067-21.333-60.8-51.2-69.333V21.333 C272.891,9.6,263.291,0,251.557,0s-21.333,9.6-21.333,21.333v94.933c-29.867,8.533-51.2,36.267-51.2,69.333 c0,5.333,1.067,10.667,2.133,16L67.024,269.867c-10.667,6.4-13.867,19.2-7.467,28.8c4.267,7.467,10.667,10.667,18.133,10.667 c3.2,0,7.467-1.067,10.667-2.133l114.133-68.267c4.267,3.2,7.467,6.4,12.8,9.6l-102.4,224c-4.267,10.667,0,22.4,10.667,27.733 c3.2,1.067,5.333,2.133,8.533,2.133c7.467,0,14.933-4.267,19.2-12.8l12.8-28.8h173.867l13.867,29.867 c3.2,7.467,11.733,11.733,19.2,11.733c3.2,0,6.4-1.067,8.533-2.133c10.667-5.333,16-17.067,10.667-27.733L287.824,249.6 c5.333-3.2,9.6-6.4,13.867-9.6l113.067,68.267c3.2,2.133,7.467,3.2,10.667,3.2c7.467,0,13.867-3.2,18.133-10.667 C448.891,289.067,445.691,276.267,436.091,269.867z M251.557,155.733c17.067,0,29.867,12.8,29.867,29.867 c0,16-12.8,29.867-29.867,29.867c-16,0-29.867-12.8-29.867-29.867C221.691,169.6,234.491,155.733,251.557,155.733z M250.491,268.8 l34.133,74.667h-67.2L250.491,268.8z M303.824,386.133l13.867,30.933h-134.4l13.867-30.933H303.824z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon-6.a6ac59a5ca437ef0df1badf0222a4aa9.svg";
export { ForwardRef as ReactComponent };